// One look for every data table in the Bundle tool (Simple/Bundle view, Component view, Data
// Health): rounded container with a soft shadow, frosted small-caps header, warm hairline
// dividers and a faint warm hover. Import these instead of re-deriving the values.
export const TABLE_BORDER = '#ECECE4';

export const tableContainerSx = {
    borderRadius: '14px',
    borderColor: TABLE_BORDER,
    boxShadow: '0 1px 2px rgba(26,20,15,0.04), 0 10px 28px rgba(26,20,15,0.05)',
    overflow: 'auto',
} as const;

export const tableHeadRowSx = {
    '& .MuiTableCell-head': {
        bgcolor: 'rgba(250, 250, 247, 0.92)',
        backdropFilter: 'blur(8px)',
        fontWeight: 700,
        fontSize: '0.66rem',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: '#6B625B',
        lineHeight: 1.2,
        py: 1.25,
        borderBottom: `1px solid ${TABLE_BORDER}`,
    },
} as const;

export const tableBodySx = {
    '& .MuiTableRow-root:not(:last-child) .MuiTableCell-body': { borderBottom: `1px solid ${TABLE_BORDER}` },
    '& .MuiTableRow-root:last-child .MuiTableCell-body': { borderBottom: 'none' },
    '& .MuiTableBody-root .MuiTableRow-root:hover': { bgcolor: '#fffaf6' },
} as const;
